<template>
    <BaseDialog
        :showDialog="showDialog"
        headline="lang_AZ_PERSONS_ACTION_SYNC_CONTACTS"
        :close="closeDialog"
        maxCardHeight="500"
        :alvqa="alvqa"
    >
        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-col>
                        <v-row>
                            <BaseEditPageDropdown 
                                :context="'Sync'+context" 
                                field="Api" 
                                :items="apiConnections"
                                :label="$t('lang_GENERIC_CAPTION_API_CONNECTIONS')" 
                                :multiple="true" 
                                :selection="true"
                                :rules="isApiFieldRequired"        
                                :alvqa="alvqa + '-dropdown-type'" 
                            />
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-col class="text-right">
                        <!-- CSV report file for Mailchimp to ALV Sync-->
                        <span v-if="csvReportFilePath !== null" class="pr-2">
                            <BaseIcon 
                                @click.stop="donwloadReport(csvReportFilePath)" 
                                icon="cloud_download" 
                                :tooltipText="$t('lang_GENERAL_CAPTION_ICON_DOWNLOAD')" 
                                :alvqa="alvqa + '-icon-download-csv-report-bulk-edit-copy-shares'" 
                            />
                        </span>
                        <span v-if="showProgressBar" class="pr-2">
                            <v-progress-circular 
                                size="16"
                                width="2"
                                color="dialogProgressbar"
                                indeterminate
                                :alvqa="alvqa + '-progress-bar-csv-report-bulk-edit-copy-shares'" 
                            ></v-progress-circular>
                        </span>
                        <BaseButton 
                            @click="apply"
                            :disabled="disableApply"
                            label="lang_GENERIC_CAPTION_APPLY"
                            :alvqa="alvqa+'-button-apply'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from "@/components/_buttons/BaseIcon"
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

import api from '@/api_alv'


export default {
    name: "SyncDataDialog",
    props: {
        context: String, // needed to get the context of the selected items, e.g. 'selectedWorks'
        dir: String, // needed for api call, to know the context, e.g. 'publishing/works'
        idAttributeName: String // needed for payload, e.g. 'workIds' or 'releaseIds'
    },
    data() {
        return {
            valid: true,
            alvqa: 'sync-data-dialog',
            disableApply: false,
            showProgressBar: false,
            csvReportFilePath: null,
        }
    },
    components: {
        BaseDialog,
        BaseButton,
        BaseIcon,
        BaseEditPageDropdown
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowSyncDataDialog },
            set(show) { this.$store.commit('setShowSyncDataDialog', show) }
        },
        apiConnections() {
            let apiArr
            let apiConnections = this.$store.getters['getApiConnections']

            if (apiConnections !== undefined) {
                apiArr = JSON.parse(JSON.stringify(apiConnections))
                apiArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-type-' + element.value.toLowerCase();
                    element['text'] = this.$t(element.text);
                });
            } else {
                apiArr = []
            }
            apiArr.sort(function (a, b) {
                let textA = a.text.toUpperCase();
                let textB = b.text.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            return apiArr
        },
        selectedApi() {
            return this.$store.getters.getSyncAzPersonsDetailsApi
        },
        isApiFieldRequired(){
            if(this.selectedApi !== null && this.selectedApi.includes('mailchimp')){
                return ''
            }else{
                return 'required'
            }
        }
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.disableApply = false
            this.showProgressBar = false
            this.csvReportFilePath = null
            this.$store.commit('setSyncAzPersonsDetailsApi', null)
        },
        async apply() {   
            this.csvReportFilePath = null
            if(this.selectedApi !== null && this.selectedApi !== undefined && this.selectedApi.includes('mailchimp')){
                this.showProgressBar = true
                this.disableApply = true
                let path  = await this.$store.dispatch('syncData', {dir: this.dir, context: this.context, ids: this.idAttributeName, api: this.$store.getters['getSyncAzPersonsDetailsApi'] })
                
                if(path){
                    this.csvReportFilePath = path
                    this.showProgressBar = false
                    
                }
            }

        },
        donwloadReport(path){
            api.getFileFromALV(path)
            this.disableApply = false
        },
    },
    mounted(){
        this.$store.commit('setApiConnections')
        this.$store.commit('setAzPersonsDetailsApi', null)
    }
}
</script>